import React, { useMemo, useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import TableContainer from "../../../components/Common/DataTableContainer"
import { fetchUsers } from "../../../redux/actions/user"
import { Button } from "reactstrap"

const UserList = () => {
  document.title = "Users List"

  const history = useNavigate()
  const dispatch = useDispatch()

  const userState = useSelector(state => state.user)

  const [userData, setUserData] = useState([])
  console.log("userData", userData)

  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "full_name",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Mobile",
        accessorKey: "mobile_no",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Email",
        accessorKey: "email_id",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "PVS No",
        accessorKey: "pvs_card_number",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Brand Name",
        accessorKey: "brand_name",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: "Registered  Date",
        accessorKey: "signup_date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <div>
              <Button
                size="md"
                color="primary"
                className="w-20 text-transform"
                onClick={() => history(`/view-user/user/${row.enc_user_id}`)}
              >
                view details
              </Button>
              {/*    <button
                className="btn btn-sm btn-primary me-2"
                onClick={() => history(`/events/edit-category/${row.url}`)}
                title="Edit Category"
              >
              <FaEdit /> 
              </button>  */}
            </div>
          )
        },
      },
    ],
    []
  )

  useEffect(() => {
    dispatch(fetchUsers({}))
  }, [])

  useEffect(() => {
    if (userState && Array.isArray(userState.users)) {
      setUserData(userState.users)
    }
  }, [userState])

  useEffect(() => {
    console.log("User data updated:", userData)
  }, [userData])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <h4 className="nom-title h4 mb-2">User List</h4>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={userData || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          isAddButton={false}
          buttonClass="btn btn-primary"
          buttonName="Add User"
          handleUserClick={() => {
            history("/add-user")
          }}
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass=" table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb- nominee-tbl-wrapper"
          key={userData?.length || 0}
        />
      </div>
    </div>
  )
}

export default UserList
